import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export const IdeaDetailSkeleton = () => {
  return (
    <div className="space-y-8">
      {/* Header Skeleton */}
      <div className="space-y-4">
        <Skeleton className="h-12 w-3/4 bg-white/40" />
        <Skeleton className="h-6 w-full bg-white/40" />
        <div className="flex gap-2">
          <Skeleton className="h-6 w-20 bg-white/40" />
          <Skeleton className="h-6 w-20 bg-white/40" />
          <Skeleton className="h-6 w-20 bg-white/40" />
        </div>
      </div>

      {/* Action Buttons Skeleton */}
      <div className="flex gap-4">
        <Skeleton className="h-10 w-32 bg-white/40" />
        <Skeleton className="h-10 w-32 bg-white/40" />
        <Skeleton className="h-10 w-32 bg-white/40" />
      </div>

      {/* Metrics Skeleton */}
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="rounded-[16px] p-4 space-y-2" style={{ background: 'rgba(255,255,255,0.72)', border: '1px solid rgba(255,255,255,0.85)' }}>
            <Skeleton className="h-4 w-24 bg-[#6b5f8a]/20" />
            <Skeleton className="h-8 w-16 bg-[#6b5f8a]/20" />
          </div>
        ))}
      </div>

      {/* Content Cards Skeleton */}
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="rounded-xl p-5 space-y-3" style={{ background: 'rgba(255,255,255,0.72)', border: '1px solid rgba(255,255,255,0.85)' }}>
          <Skeleton className="h-6 w-40 bg-[#6b5f8a]/20" />
          <Skeleton className="h-4 w-full bg-[#6b5f8a]/20" />
          <Skeleton className="h-4 w-full bg-[#6b5f8a]/20" />
          <Skeleton className="h-4 w-3/4 bg-[#6b5f8a]/20" />
        </div>
      ))}
    </div>
  );
};
